<template>
    <div class="bg-white text-white" :style="[bgColor ? `background-color: ${bgColor}` : '', fgColor ? `color: ${fgColor}` : '', computedPaddingStyle]">
        <Container>
            <div class="grid grid-cols-1 lg:grid-cols-2 gap-4 lg:gap-32 px-4 lg:px-0">
                <!--
                    Click-to-play. Nothing reaches YouTube — and none of its cookies are set —
                    until the visitor presses play. The facade also parses the video id out of
                    whatever the editor pasted, which matters here because this widget's config
                    is a plain text field: a raw watch?v= link used to go straight into src,
                    and YouTube refuses to be framed from that URL, so the box rendered blank.
                    The empty box is kept when the link is unusable, so the layout is unchanged.
                -->
                <div class="w-full bg-neutral-100 order-2 lg:order-1 rounded-lg overflow-hidden" style="aspect-ratio: 16 / 9;">
                    <YouTubeFacade :video-url="youtubeUrl" :label="heading" />
                </div>
                <div class="flex flex-col justify-around lg:py-8 space-y-4 order-1 lg:order-2">
                    <h2 class="text-2xl lg:text-4xl font-semibold">{{ heading }}</h2>
                    <div v-html="content"></div>
                    <div class="hidden lg:grid grid-cols-2 gap-4">
                        <ButtonComponent
                        v-bind="cta1Button" />
                        <ButtonComponent
                        v-bind="cta2Button" />
<!--                        <a v-if="cta1 && cta1.type == 'url'" :href="cta1.url" class="text-black bg-[#E2734A] hover:bg-[#E2734A] hover:scale-105 px-4 py-3 rounded-xl duration-150 shadow-sm font-semibold flex items-center justify-center">{{ cta1.label }}</a>-->
<!--                        <a v-if="cta2 && cta2.type == 'url'" :href="cta2.url" class="text-black bg-[#95D2F2] hover:bg-[#95D2F2] hover:scale-105 px-4 py-3 rounded-xl duration-150 shadow-sm font-semibold flex items-center justify-center">{{ cta2.label }}</a>-->
                    </div>
                </div>
            </div>
        </Container>
    </div>
</template>

<script>
import Container from '../../../Layouts/Container.vue'
import PaddingMixin from '../../components/mixins/PaddingMixin.js'
import ButtonComponent from "../../basics/Button/Component.vue";
import YouTubeFacade from '../../components/reusables/YouTubeFacade.vue'

export default {
    components: {
        Container,
        ButtonComponent,
        YouTubeFacade
    },
    mixins: [PaddingMixin],
    props: {
        heading: String,
        content: String,
        youtubeUrl: String,
        bgColor: String,
        fgColor: String,
        cta1Button:{type:Object},
        cta2Button: {
            type: Object
        },
    }
}
</script>
